import FormCategory from "../models/FormCategory";

export default class FormCategoryMapper {
    public map(data: any): FormCategory {
        const category: FormCategory = new FormCategory();
        if (data) {
            category.name = data.Name;
            category.id = data.ID;
        }

        return category;
    }
}